import styled from 'styled-components';

export const TopBlock = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  & .image {
    img {
      width: 20rem;
      margin-right: 1rem;
      margin-top: 1rem;
    }
  }
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
  margin-left: 1.5rem;
  & > .subtitle {
    height: 1.5rem;
    width: 35.563rem;
    left: 1.5rem;
    top: 7rem;
  }
`;
